/**
 * @desc 已处理信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.exportDeclaration.yclExportDeclaration.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/yclExportDeclaration`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
